
module.exports = window.$;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/jquery.js